import axios from "axios";
import React, { Component } from "react";
import ConstantUrl from "../util/ConstantUrl";
import { Parser } from "html-to-react";
import { Link } from "react-router-dom";
export default class HealthLibrary extends Component {
  constructor(props) {
    super(props);
    this.state = {
        homeLibrarydata: [],
    };
    this.URL = new ConstantUrl();
  }

  async componentDidMount() {
    const URL = new ConstantUrl();

    await axios.post(URL.homeLibrary).then((response) => {
      const homeLibrarydata = response.data["data"];

      this.setState({ homeLibrarydata });
    });
  }

  render() {
    return (
      <>
        {/* {{-- =============================================
                    BREADCRUMB
    ============================================  --}} */}
        <section id="breadcrumb">
          <div className="container-fluid">
            <div className="container">
              <div className="breadcrumb-bar">
                <div>
                  <Link to="/home">Home</Link>
                </div>
                <div>
                  &nbsp; <i className="fa-solid fa-minus"></i> &nbsp;
                </div>
                <div>HealthLibrary</div>
              </div>
            </div>
          </div>
          <hr className="m-0" />
        </section>

        {/* {{-- =============================================
                    HealthLibrary AREA
    ============================================  --}} */}
        <section id="remedies-area">
          <div className="section-gap">
            <div className="container-fluid">
              <div className="container">
                <div className="remedies-grid">
                  <div className="row">
                    {this.state.homeLibrarydata.map((health) => (
                      <div className="col-lg-3 col-md-4 col-sm-6">
                        <Link to={`/HealthLibrabryDetails/${health.id}`}>
                          <div className="remedy-card">
                            <div className="remedy-img">
                              <img
                                src={
                                  this.URL.blogsPhotoUrl + health.image
                                }
                                alt="..."
                                className="w-100 h-100"
                              />
                            </div>
                            <div className="remedy-content">
                              <div className="remedy-head text-truncate">
                                {health.name}
                              </div>
                              <div className="remedy-data">
                                {Parser().parse(health.des)}
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
